import { html } from 'lit';

export const iconRejectCircle = html`
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M72 36C72 55.9688 55.8281 72 36 72C16.0312 72 0 55.9688 0 36C0 16.1719 16.0312 0 36 0C55.8281 0 72 16.1719 72 36ZM12.0938 15.4688C7.3125 20.9531 4.5 28.125 4.5 36C4.5 53.4375 18.5625 67.5 36 67.5C43.875 67.5 51.0469 64.6875 56.5312 59.9062L12.0938 15.4688ZM67.5 36C67.5 18.7031 53.2969 4.5 36 4.5C27.9844 4.5 20.8125 7.45312 15.3281 12.2344L59.7656 56.6719C64.5469 51.1875 67.5 44.0156 67.5 36Z"
      fill="currentColor"
    />
  </svg>
`;
